import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import {TextField} from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'
import PaginationComponent from '../PaginationComponent';

class AdminCouponDetailsForUser extends Component {

  constructor(props){
    super(props);
    this.state ={
      pageNumber: 1,
      itemsPerPage: 100,
      totalCount: '',
      errorMsg: '',
      noDataFound: '',
      data: {
        institutionsList: [],
        institutionId: '',
        userCouponDetails: [],
      }
    }
  }

  componentDidMount(){
    const data = Object.assign({}, this.state.data);
    return api.getInstitutionList(this.props.user.accessToken)
    .then((result) => {
      if(result.status === 'success'){
        data.institutionsList = result.data
        this.setState({data: data})
      }
    })
  }

  handleInstitutionChange = (event) => {
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      let selectedOption = event.target.value
      data.institutionId = selectedOption
      var optionElement = event.target.childNodes[event.target.selectedIndex]
    }
    else {
      data.institutionId = ''
    }
    if(data.institutionId) {
      api.getAllottedCouponDetailsForUser(this.props.user.accessToken, data.institutionId, this.state.pageNumber, this.state.itemsPerPage)
      .then((result) => {     
        if (result.status === 'success') {
          if(result.data.length > 0) {
            data.userCouponDetails = result.data
            this.setState({data: data, totalCount: result.count, noDataFound: ''})
          }
          else if(result.data.length === 0){
            data.userCouponDetails = []
            this.setState({noDataFound: 'No data found for this institution.', data: data})
          }
        }
        else if(result.status === 'error'){
          this.setState({ errorMsg: result.errors })
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
  }

  handlePaginationChange = (pageNo) => {
    const data = Object.assign({}, this.state.data);
    api.getAllottedCouponDetailsForUser(this.props.user.accessToken, this.state.data.institutionId, pageNo, this.state.itemsPerPage)
      .then((result) => {     
        if (result.status === 'success') {
          data.userCouponDetails = result.data
          this.setState({data: data, totalCount: result.count})
        }
        else if(result.status === 'error'){
          this.setState({ errorMsg: result.errors })
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
  }

  goBack = () => {
    this.props.history.push('/portal/app/admin/coupons')
  }

  render() {
    let userListCompnent
    let paginationKey = this.state.totalCount
    
    if(this.state.data.userCouponDetails.length >0){
      userListCompnent = 
        ( <tbody>
            {this.state.data.userCouponDetails.map(function(user) {
              return(
              <tr>
                <td>{user.user_id}</td>
                <td>{user.user_name}</td>
                <td>{user.tq_test_track_name}</td>
                <td>{user.coupon_code_name}</td>
                <td>{user.created_at.split('T')[0]}</td> 
                <td>{user.email}</td>
                <td>{user.phone}</td>
              </tr>)
            })}
          </tbody>  
        )
    }
    return (
      <Card>
        <Grid>
          <GridCell span="10"><Typography use="headline5">Coupon Allotted for Users</Typography></GridCell>
          <GridCell span="2"><Button raised onClick={this.goBack}>Go Back</Button></GridCell>
        </Grid>
        <Grid className="opportunity-list-item">
          <GridCell span="6">
            <div className="full-width">
              <div className="mdc-select" role="listbox">
                <select 
                  name="testcenter"
                  onChange={this.handleInstitutionChange}
                  value={this.state.institutionId}
                  className="mdc-select__native-control two-col-input"
                >
                  <option value="0" selected="">--Select Institution--</option>
                  {this.state.data.institutionsList.map(institution => (
                    <option key={institution.id} value={institution.id} data-name={institution.name} track-amount={institution.amount}>
                      {institution.name} 
                    </option>
                  ))}
                </select>
                <label className="mdc-floating-label mdc-floating-label--float-above">Institution Name</label>
                <div className="mdc-line-ripple"></div>
              </div>
            </div>
          </GridCell>
        </Grid>
        <Grid>
          <GridCell span="12">
            <div>
              <table className="admin-table">
                <th>User ID</th>
                <th>User Name</th>
                <th>TQ Subject Track</th>
                <th>Coupon Applied</th>
                <th>Registered on</th>
                <th>Email</th>
                <th>Phone</th>
                {userListCompnent}
              </table>
            </div>
            <div key={paginationKey}>
              <PaginationComponent totalItems = {this.state.totalCount}
              itemsPerPage = {this.state.itemsPerPage} 
              onHandleItemsFetch = {this.handlePaginationChange} />
            </div>
          </GridCell>
        </Grid>
          <StatusMessage error_msg = {this.state.errorMsg}/>
          <StatusMessage error_msg = {this.state.noDataFound}/>
      </Card>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCouponDetailsForUser);


// WEBPACK FOOTER //
// ./src/views/admin/AdminCouponDetailsForUser.jsx